<template>
    <div class="logo">
        <h1 class="text-center mb-5">Autenticando...</h1>

        <DialogCommercialHierarchyLogin v-model="dialogCommercialHierarchyVisible" :items="commercialHierarchyData" :show-close-button="false" />
        <DialogCommercialHierarchyAssistentLogin v-model="dialogAssistentCommercialHierarchyVisible" :items="commercialHierarchyAssistentData" @validateHierarchyReturn="validateHierarchyReturn" />
    </div>
</template>

<script>
  import { flavorRes, loadFlavor } from '../plugins/flavors'
  import { autenticarNewCon } from '../webservice/autenticar'
  import { alert, error, findUnidade, notification } from '../plugins/helpers'
  import { origensAcesso } from '@/plugins/constants'
  import DialogCommercialHierarchyLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyLogin.vue'
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import DialogCommercialHierarchyAssistentLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyAssistentLogin.vue'

  export default {
    name: 'LoginExterno',
    components: { DialogCommercialHierarchyAssistentLogin, DialogCommercialHierarchyLogin },
    mixins: [commercialHierarchy],
    data: () => ({
      logo: ''
    }),
    mounted () {
      this.$session.destroy()
      loadFlavor('rodobens')
      this.logo = flavorRes('img/logo-menu.png')

      const params = this.$route.query
      autenticarNewCon(params.ext_Login, params.ext_Senha, true)
        .then(res => {
          this.$session.set('origem_acesso', origensAcesso.link_externo)

          if (!this.verifyIfLoginIsCommercialHierarchy(res)) {
            const empresas = res.data.Empresas.Empresa
            const unidades = res.data.UnidadesNegocio
            const empresa = empresas.find(empresa => empresa.CD_Empresa === params.CD_Empresa)
            if (empresa) {
              this.$session.set('id_empresa', this.$session.get('vendas_backoffice') ? 0 : empresa.ID_Empresa)
              if (!this.$session.get('vendas_backoffice')) {
                this.$session.set('empresas', [empresa])
              }
              const filiais = res.data['FiliaisVenda']['FilialVenda']

              if (filiais) {
                this.$session.set('filiais', filiais)
                this.$session.set('filial', filiais.find(filial => filial.ID_Empresa === empresa.ID_Empresa))
              }
            } else {
              alert(`A empresa ${params.CD_Empresa} é inválida. Consulte a administradora`)
              return
            }
            const unidade = findUnidade(params.CD_Unidade_Negocio, empresa.ID_Empresa, unidades, this.$session.get('vendas_backoffice'))
            if (unidade) {
              this.$session.set('id_unidade_negocio', unidade.id_unidade_negocio)
              this.$session.set('unidades', [unidade])
            } else {
              alert(`A Unidade de Negócio ${params.CD_Unidade_Negocio} é inválida. Consulte a administradora`)
              return
            }
          }

          /** @var id_representante string **/
          let id_representante = params.ext_identificador_representante || null

          if (id_representante && id_representante.length > 30) {
            notification('warning', 'Identificador do representante inválido.')
            return
          }

          this.$session.set('identificador_representante_tribanco', id_representante)
          this.$session.set('id_pedido_detalhes_venda', 0)

          if (!this.validateHierarchyReturn(res)) {
            this.$router.replace('/')
          }
        })
        .catch(error)
    }
  }
</script>

<style scoped>
    .logo {
        width: 100%;
        margin-top: 15px;
    }

    .logo img {
        margin: auto;
        display: block;
    }
</style>
